export default __webpack_public_path__ + "static/digitalFinancialLogo-8a92774d88e53956e39aa790e9720813.png";